module.exports = __webpack_public_path__ + "static/media/035-Greta YEG.0b5ce3e4.jpg";